module.exports = __webpack_public_path__ + "static/media/SpoqaHanSansNeo-Thin.c9026604.woff2";